module.exports = __webpack_public_path__ + "static/event-4-8d9ac19e3b41f5fbd4f744b2830e219c.gif";